import axios from "axios";

export const createComment = async (username, commentVOToCreate) => {
    try {
        const {data} = await axios.post("/api/comment/create", {username, commentVOToCreate});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const updateComment = async (username, commentVOToUpdate) => {
    try {
        const {data} = await axios.put("/api/comment/update", {username, commentVOToUpdate});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const deleteComment = async (username, externalReference) => {
    try {
        const {data} = await axios.delete("/api/comment/delete", {data: {username, externalReference}});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const retrieveAllComments = async (username, contextExternalReference) => {
    try {
        const {data} = await axios.get("/api/comment/viewAll?username=" + username + "&contextExternalReference=" + contextExternalReference);
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const createView = async (username, viewerVOToCreate) => {
    try {
        const {data} = await axios.post("/api/viewer/create", {username, viewerVOToCreate});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const retrieveAllViews = async (username, contextExternalReference) => {
    try {
        const {data} = await axios.get("/api/viewer/viewAll?username=" + username + "&contextExternalReference=" + contextExternalReference);
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}
